import { BaseDelayType } from '../../DelayTypes/BaseDelayType'
import { DelayDataLimitType, DelayType } from '../../DelayTypes/types'

export abstract class ProxyBaseDelayType {
  abstract type: DelayType
  abstract getModel(): BaseDelayType
}

export abstract class ProxyBaseDelayTypeWithInterval extends ProxyBaseDelayType {
  abstract limit: DelayDataLimitType | null

  switchLimit(val: boolean): void {
    if (val) {
      this.limit = {
        from: '',
        to: '',
        days_of_week: [],
      }
    } else {
      this.limit = null
    }
  }

  setLimitFrom(time: string): void {
    if (this.limit) {
      this.limit.from = time
    }
  }

  setLimitTo(time: string): void {
    if (this.limit) {
      this.limit.to = time
    }
  }

  setLimitDaysOfWeek(days: Array<number>): void {
    if (this.limit) {
      this.limit.days_of_week = days
    }
  }
}
